import React, { memo } from 'react';

import { TableContainer, BaseTableProps } from '../../components';

type LogsTableProps = {} & BaseTableProps;

const AccommodationsTable: React.FunctionComponent<LogsTableProps> = memo(props => {
    console.debug('LogsTable');

    return <TableContainer {...props} columns={props.columns} dataSourcePath="" />;
});

export default AccommodationsTable;
